<template>
  <div class="container image-block">
    <img :src="moduleData.src || ''" :alt="moduleData.alt || 'Image alt text.'" />
  </div>
</template>

<script>
export default {
  props: {
    moduleData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>